module.exports = __webpack_public_path__ + "img/default-thumbnail.6130fff7.png";